
class FormIdentification extends require('common/helpers/validate') {
   // Validation schema
   get schema() {
      return {
         username: {
            required: true,
            type: 'string',
            format: /^\d{8}$/
         },
         dateofbirth: {
            required: true,
            type: 'date'
         }
      }
   }

   get messages() {
      return {
         'username.required': 'msg:username error',
         'username.format': 'msg:username error',
         'dateofbirth.required': 'msg:dob error',
         'dateofbirth.date': 'msg:dob error'
      }
   }
}

module.exports = FormIdentification
